import { BudgetDetailed, ListClientBudget } from "Dtos/IBudget";
import API from "Services/Api";
import { createFilterParams } from "Utils/searchFilters";
import { Moment } from "moment";

export type RegisterProductOnCartProps = {
  budget_id: boolean | number;
  patient_id: number;
  item: {
    amount: number;
    product_id: number;
  };
};

export type Filters = {
  search: string;
  page_size: string;
  page: number;
  start_date: Moment | undefined;
  end_date: Moment | undefined;
  status_id: string;
  client_id: string;
};

export type FiltersReq = Omit<Filters, "start_date" | "end_date"> & {
  start_date: string | undefined;
  end_date: string | undefined;
  home_collected?: string;
};

export interface GetClientBudgets {
  data: ListClientBudget[];
  meta: {
    pagination: {
      count: number;
      current_page: number;
      per_page: number;
      total: number;
      total_pages: number;
    };
  };
}

export const listAllClientsBudget = async (
  filters: FiltersReq
): Promise<GetClientBudgets> => {
  const response = await API.get("/clients/budgets", {
    params: createFilterParams(filters),
  });
  return response.data;
};

export const convertBudgetToOrder = async (budgetId: number): Promise<void> => {
  try {
    const response = await API.post(`/orders/clients/convert-budget`, {
      budget_id: budgetId,
    });
    return response.data;
  } catch (error: any) {
    throw error.response.data.error;
  }
};

export const registerProductOnBudgetCart = async (
  data: RegisterProductOnCartProps
) => {
  const response = await API.post(`/clients/budgets/cart`, {
    ...data,
    coupon_code: "",
    budget_type: 1,
    last_menstruation_period: "",
    home_collected: true,
    symptoms: "",
    item: {
      ...data.item,
      voucher: "",
    },
  });
  return response.data;
};

// lista itens de carrinho do orçamento
export const listProductsOnBudgetsCart = async (
  preOrderId: number
): Promise<BudgetDetailed> => {
  const response = await API.get(`/clients/budgets/${preOrderId}`);
  return response.data;
};
